import React from "react";
import { useState, forwardRef, useEffect } from "react";
import "./NavTabsNew.css";
import { BiUpload, BiDownload } from "react-icons/bi";
import MonthlyTable1 from "./TableComponents/MonthlyTable1_new";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import Moment from 'moment';
import Modal from 'react-modal';
import { IoClose } from 'react-icons/io5';
import { FaRegCalendarAlt } from 'react-icons/fa';
import mailData from '../data/mailData.js';
// import  '../Components/AdminPage.css';
var fileDownload = require('js-file-download');

function NavTabs() {
  const [toggleState, setToggleState] = useState(1);
  const [fromStartDate, setFromStartDate] = useState(new Date("2023/11/01"));
  var now = new Date();
  const [toEndDate, setToEndDate] = useState(new Date(now.getFullYear(), now.getMonth() + 2));
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [modalIsOpen, setIsOpen] = useState(false);

  const [file, setFile] = useState({ name: '' });
  const [uploadDateSelected, setUploadDateSelected] = useState(new Date());
  const [response, setResponse] = useState('');

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const [courses, setCourses] = useState([]);

  const getData = (month, year) => {
    // axios.get(`http://localhost:4002/courses/${month.toUpperCase()}/${year}`,
    axios.get(`https://atci.lkm-securitylearninghub.accenture.com/securitylearninghub-apis/courses/${month.toUpperCase()}/${year}`,
      {
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
          'Authorization': localStorage.getItem("token"),
          'Content-Type': 'application/json'
        }
      },)
      .then(response => {
        setCourses(response.data.data);
      })
      .catch(err => {
        // console.log(err)
        setCourses([]);
      })
  }

  const getFile = (month, year) => {
    // axios.get(`http://localhost:4002/download/${month.toUpperCase()}/${year}`,
    axios.get(`https://atci.lkm-securitylearninghub.accenture.com/securitylearninghub-apis/download/${month.toUpperCase()}/${year}`,
      {
        responseType: 'blob',
        headers: {
          'Authorization': localStorage.getItem("token"),
          'Content-Type': 'application/json'
        }
      }
    )
      .then(response => {
        console.log('File Downloaded');
        fileDownload(response.data, `${month.toUpperCase()}-${year}.xlsx`);
      })
      .catch(err => {
        console.log(err)
      })
  }

  const handleDateChange = (date) => {
    setSelectedDate(date);
    getData(Moment(date).format('MMM'), Moment(date).format('YYYY'));
  }

  useEffect(() => {
    setTimeout(() => {
      getData(Moment().format('MMM'), Moment().format('YYYY'));
    }, [1000])
  }, [])
  const DatePickerInput = forwardRef(({ value, onClick }, ref) => (
    <button className="sap-date-picker-btn" onClick={onClick} ref={ref}>
      {value}
      {/* <div className="admin_calender_button" onClick={onClick} ref={ref}>
         Click here to Select
         <FaRegCalendarAlt className="admin_calendar-icon" />
       </div> */}
    </button>
  ));

  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(0,0,0,.4)'
    },
    content: {
      top: '40%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      padding: '10px 20px 20px 20px'
    },
  };

  const handleUploadDateChange = (date) => {
    setUploadDateSelected(date);
  }

  const handleChange = (e) => {
    setFile(e.target.files[0]);
    console.log(e.target.files[0].type);

    if (e.target.files[0].type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      // setFileValidation('Please upload only excel file.');  
      return;
    }
    setResponse('');
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': localStorage.getItem("token"),
        // 'Content-Type': 'application/json'
      },
    };
    // axios.post(`http://localhost:4002/courses/${Moment(uploadDateSelected).format('MMM').toUpperCase()}/${Moment(uploadDateSelected).format('YYYY')}`,
    axios.post(`https://atci.lkm-securitylearninghub.accenture.com/securitylearninghub-apis/courses/${Moment(uploadDateSelected).format('MMM').toUpperCase()}/${Moment(uploadDateSelected).format('YYYY')}`,
      formData,
      config
    )
      .then(res => {
        setFile({ name: '' });
        setResponse('Successfully Published');
      })
      .catch(err => console.log(err))
  }

  const handleDownload = () => {
    getFile(Moment(selectedDate).format('MMM'), Moment(selectedDate).format('YYYY'));
  }

  return (
    <>
    {console.log(localStorage.getItem("token"), "tokennn")}
      <div className={toggleState === 1 ? "active__content" : "content"}>
        {/* <h5 className="heading__month_title">
          LKM SAP Ascend Learning Calendar - {Moment(selectedDate).format('MMMM, YYYY')}
        </h5> */}
        <h2 className="heading calendar-heading">
          Security Learning Hub Calendar - {Moment(selectedDate).format('MMMM, YYYY')}
        </h2>
      </div>

      <div className="tab-container">
        <div>
          <span className="sap-date-piocker-label"> Select month : </span> &nbsp;
          <div className="sap-date-picker">
            <FaRegCalendarAlt className="admin_calendar-icon" />
            <DatePicker
              selected={selectedDate}
              onChange={(date) => handleDateChange(date)}
              minDate={fromStartDate}
              maxDate={new Date("2024/12/31")}
              showMonthYearPicker
              dateFormat="MMMM, yyyy"
              customInput={<DatePickerInput />}
            />

          </div>
        </div>
        <div>

          <button type="button" className="sap-calendar-file-upload" onClick={openModal}>
            Admin {"  "}&nbsp;
            <span style={{ fontSize: "1.5rem" }}>
              <BiUpload />
            </span>
          </button>
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
          >
            <div class="modal-header"><div class="modal-title" id="contained-modal-title-vcenter">File Upload</div>
              <span onClick={closeModal} className="upload-modal-close-btn"><IoClose /></span>
            </div>

            <div className="upload-modal-content">
              <span className="sap-date-piocker-label">Select month :</span>
              <div className="sap-date-picker">

                <DatePicker
                  selected={uploadDateSelected}
                  onChange={(date) => handleUploadDateChange(date)}
                  minDate={fromStartDate}
                  maxDate={new Date("2024/12/31")}
                  showMonthYearPicker
                  dateFormat="MMMM, yyyy"
                  customInput={<DatePickerInput />}
                />
                <FaRegCalendarAlt className="admin_calendar-icon" />
              </div>
              <form onSubmit={handleSubmit} className="file-upload-form">
                <div className="uploadBtn-box">
                  <input class="input-file" id="my-file" type="file" onChange={handleChange} hidden />
                  <label>Select File to Upload :</label>
                  <label for="my-file" class="custom-upload-btn"><span className="uploadIcon"> &uArr;</span> {file.name ? 'File selected' : 'Upload File'}</label>
                  {file.name ? <p class="uploaded-file-name">{file.name}</p> : <p class="uploaded-file-name">No file selected</p>}
                </div>
                {file.name ? <button type="submit" className="file-sub-btn">Publish Calendar</button> : <button className="file-sub-btn file-sub-btn-inactive" disabled >Publish Calendar</button>}
                {<span class="uploaded-response">{response}</span>}
                <div>
                  <span className="lkm-calendar-upload-instructions">Instructions</span>
                  <div>
                    <ol className="Instructions-List">
                      {/* <li>
                        To publish the calendar by uploading the template, in case if there is any doubt or clarification please refer the <a href="images/SAPAscendCalendar-Job Aid.docx" className="lkm-calendar-sample-file">job aid</a>.
                      </li> */}
                      <li>
                        The calendar needs to be uploaded in a given template format. Any change in the template will lead
                        to upload failure or error messages.
                        <a href={require("../data/SampleCalendar.xlsx")} target="_blank" className="lkm-calendar-sample-file"
                          rel="noreferrer"> Click here </a>
                        to download the calendar template.
                      </li>
                      <li>
                        For a successful upload of new calendar data every time use new excel file, avoid making changes to the older one.
                      </li>
                      <li>
                        Please avoid uploading or updating the calendar frequently to avoid any issues. In case if any corrections
                        required and its unavoidable please re-upload the calendar again and publish the calendar.
                      </li>
                      {/* <li>
                              Please do not exceed maximum three times of uploading or correcting the calendar for the respective 
                              month as per the governance and terms.
                          </li>*/}
                      <li>
                        Uploaded calendar can be modified to the max of 3 times.
                      </li>
                      {/* <li>
                              Whenever there is an update or upload happens on the calendar, mailer notification will be sent to 
                              the respective admins and developers.
                          </li> */}
                      <li>
                        In case if you need to add or remove access for admin page please contact <a href={`mailto:${mailData.atcilkmlisportaldevelopment}`} className="lkm-calendar-sample-file">{`${mailData.atcilkmlisportaldevelopment}`}</a>
                      </li>
                      <li>
                        Whenever there is a change in the calendar page, admins will be notified via mail
                      </li>
                      <li>
                        <strong>The members who have admin access :</strong>
                        <table className="table_Names">
                          <tr>
                            <td>h.srinivasan</td>
                            <td>jeevadharani.ramanan</td>
                            <td>ankur.e.mishra</td>
                            {/* <td>s.rao.masipeddi</td> */}
                            <td>reshmi.haridas</td>
                          </tr>
                          <tr>
                            {/* <td>v.a.aravind.kumar</td> */}
                            <td>aayushi.bharti</td>
                            <td>arpita.m.singh</td>
                            {/* <td>kusume.sridhar</td> */}
                            {/* <td>rajath.mb</td> */}
                            <td>uma.rani.battu</td>
                            <td>aluru.akash</td>
                          </tr>
                          <tr>
                            <td>j.b.bhardwaj</td>
                            <td>shramika.s.ambolkar</td>
                            <td>sunil.l.singh</td>
                            <td>abhishek.r.pandey</td>
                            {/* <td>manasa.velagaleti</td> */}
                          </tr>
                        </table>
                      </li>
                    </ol>
                  </div>
                </div>
              </form>
            </div>
          </Modal>
          &nbsp;
          <button onClick={handleDownload} className="sap-calendar-file-download">
            Download {"  "}&nbsp;
            <span style={{ fontSize: "1.5rem" }}>
              <BiDownload />
            </span>
          </button>
        </div>
      </div>
      <div className="container__fluid">
        <MonthlyTable1 data={courses} />
      </div>
      {console.log(courses, "courses")}
    </>
  );
}

export default NavTabs;
